import React from 'react';
import BirthdayList from '../components/BirthdayList';

const Birthday: React.FC = () => {
  return (
    <div className="flex-1 flex flex-col">
      <BirthdayList />
    </div>
  );
}

export default Birthday;
